// extracted by mini-css-extract-plugin
export default {"createProgramForm":"createProgramListForm_createProgramForm__L5I+D","programHeading":"createProgramListForm_programHeading__075eg"};